export default {
  MANDATE: 'mandate',
};
